export default {
  errorMessage: {
    startAtUtc: 'The start time cannot be later than the end time.',
    endAtUtc: 'The end time cannot be earlier than the start time.',
  },
};
